import i18n from './../../../shared/i18n';

import BaseModel from "../../../core/components/input-widget/BaseModel";
import {getPasswordRegex, getPhoneRuleObj} from "@/plugins/vee-validate";

export default class AuthenticatorCodeModel extends BaseModel {
  code = null;


  rules = {
    code: 'required|min:6|max:6|numeric',
  };

  attributeLabels = {
    code: i18n.t('Code'),
  }
}
